import { createAction, props } from '@ngrx/store';

import { IIframeMessageType, ISite, SiteSelectorOptions } from '@shared/types';

export const GET_SITES = 'GET_SITES';
export const GET_SITES_SUCCESS = 'GET_SITES_SUCCESS';
export const GET_SITES_FAILURE = 'GET_SITES_FAILURE';

export const ADD_SITES = 'ADD_SITES';
export const ADD_SITES_SUCCESS = 'ADD_SITES_SUCCESS';
export const ADD_SITES_FAILURE = 'ADD_SITES_FAILURE';

export const GET_RECENT_SITES_LIST = 'GET_RECENT_SITES_LIST';
export const GET_RECENT_SITES_LIST_SUCCESS = 'GET_RECENT_SITES_LIST_SUCCESS';
export const GET_RECENT_SITES_LIST_FAILURE = 'GET_RECENT_SITES_LIST_FAILURE';

export const SITE_SELECTION_REQUEST = 'SITE_SELECTION_REQUEST';
export const SITE_SELECTION_SUCCESS = 'SITE_SELECTION_SUCCESS';
export const SHOW_SITE_SELECTOR = 'SHOW_SITE_SELECTOR';
export const SHOW_SITE_SELECTOR_FINISH = 'SHOW_SITE_SELECTOR_FINISH';
export const SHOW_SITE_SELECTOR_SUCCESS = 'SHOW_SITE_SELECTOR_SUCCESS';

export const SITE_SELECTION_FROM_PORTAL = 'SITE_SELECTION_FROM_PORTAL';
export const CONFIGURABLE_SITE_SELECTION_FROM_PORTAL = 'CONFIGURABLE_SITE_SELECTION_FROM_PORTAL';
export const UPDATE_PREV_SELECTED_SITES = 'UPDATE_PREV_SELECTED_SITES';

export const UPDATE_SITE_SELECTION = 'UPDATE_SITE_SELECTION';
export const UPDATE_SITE_SELECTION_SUCCESS = 'UPDATE_SITE_SELECTION_SUCCESS';
export const UPDATE_SITE_SELECTION_FAILURE = 'UPDATE_SITE_SELECTION_FAILURE';

export const CLEANUP_FILTER_ON_DESTROY = 'CLEANUP_FILTER_ON_DESTROY';

export const REMEMBER_SELECTED_SITES = 'REMEMBER_SELECTED_SITES';

export const get_sites = createAction(`[SITES_REDUCER] ${GET_SITES}`);
export const get_sites_failure = createAction(`[SITES_REDUCER] ${GET_SITES_FAILURE}`);
export const get_sites_success = createAction(
    `[SITES_REDUCER] ${GET_SITES_SUCCESS}`,
    props<{ sites: Array<ISite>; prevSelectedSite: ISite; prevSelectedSites: Array<ISite> }>(),
);

export const add_sites = createAction(`[SITES_REDUCER] ${ADD_SITES}`, props<{ sites: Array<ISite> }>());
export const add_sites_success = createAction(`[SITES_REDUCER] ${ADD_SITES_SUCCESS}`, props<{ sites: Array<ISite> }>());
export const add_sites_failure = createAction(`[SITES_REDUCER] ${ADD_SITES_FAILURE}`);

export const site_selection = createAction(`${SITE_SELECTION_REQUEST}`, props<{ msg: IIframeMessageType }>());
export const site_selection_success = createAction(`${SITE_SELECTION_SUCCESS}`, props<{ msg: IIframeMessageType }>());

export const site_selection_from_portal = createAction(`${SITE_SELECTION_FROM_PORTAL}`, props<{ payload: any }>());
export const configurable_site_selection_from_portal = createAction(
    `${CONFIGURABLE_SITE_SELECTION_FROM_PORTAL}`,
    props<{ payload: any }>(),
);
export const update_prev_selected_sites = createAction(
    `${UPDATE_PREV_SELECTED_SITES}`,
    props<{ prevSelectedSite: ISite; prevSelectedSites: Array<ISite>; isMultiple: boolean }>(),
);

export const get_recent_sites = createAction(
    `${GET_RECENT_SITES_LIST}`,
    props<{ msgOptions: { messageId: string } }>(),
);
export const get_recent_sites_failure = createAction(`${GET_RECENT_SITES_LIST_FAILURE}`);
export const get_recent_sites_success = createAction(
    `${GET_RECENT_SITES_LIST_SUCCESS}`,
    props<{ msg: IIframeMessageType }>(),
);

export const show_site_selector = createAction(
    `${SHOW_SITE_SELECTOR}`,
    props<{
        options: SiteSelectorOptions;
        msgOptions: {
            messageId: string;
        };
    }>(),
);
export const show_site_selector_finish = createAction(SHOW_SITE_SELECTOR_FINISH);
export const show_site_selector_success = createAction(
    `${SHOW_SITE_SELECTOR_SUCCESS}`,
    props<{ msg: IIframeMessageType }>(),
);

export const update_site_selection = createAction(
    `[SITE_REDUCER] ${UPDATE_SITE_SELECTION}`,
    props<{ sites: Array<ISite>; prevSelectedSites: Array<ISite>; prevSelectedSite: ISite; isMultiple: boolean }>(),
);
export const update_site_selection_success = createAction(
    `[SITE_REDUCER] ${UPDATE_SITE_SELECTION_SUCCESS}`,
    props<{ sites: Array<ISite>; prevSelectedSites: Array<ISite>; prevSelectedSite: ISite; isMultiple: boolean }>(),
);
export const update_site_selection_failure = createAction(`[SITE_REDUCER] ${UPDATE_SITE_SELECTION_FAILURE}`);
export const remember_selected_sites = createAction(
    `[SITE_REDUCER] ${REMEMBER_SELECTED_SITES}`,
    props<{ selectedSite: ISite; selectedSites: Array<ISite> }>(),
);

export const cleanup_filter_on_destroy = createAction(
    `[SITE_REDUCER] ${CLEANUP_FILTER_ON_DESTROY}`,
    props<{ selectedSite: ISite; selectedSites: Array<ISite> }>(),
);
